var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Max days for UAD re-schedule")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UADrescheduledays),
      expression: "UADrescheduledays"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UADrescheduledays')
    },
    attrs: {
      "type": "text",
      "name": "UADrescheduledays",
      "id": "UADrescheduledays",
      "placeholder": "Enter UAD re-schedule days"
    },
    domProps: {
      "value": (_vm.UADrescheduledays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UADrescheduledays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showflag),
      expression: "showflag"
    }],
    staticClass: "text-success"
  }, [_vm._v("Current Value : " + _vm._s(_vm.currentUADrescheduledays))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v("Max UAD attempts per shipment")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Consignee reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Consigneereason),
      expression: "Consigneereason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Consigneereason')
    },
    attrs: {
      "type": "text",
      "name": "Consigneereason",
      "id": "Consigneereason",
      "placeholder": "Enter Number of attempts"
    },
    domProps: {
      "value": (_vm.Consigneereason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Consigneereason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showflag),
      expression: "showflag"
    }],
    staticClass: "text-success"
  }, [_vm._v("Current Value : " + _vm._s(_vm.currentConsigneereason))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Operations reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Operationsreason),
      expression: "Operationsreason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Operationsreason')
    },
    attrs: {
      "type": "text",
      "name": "Operationsreason",
      "id": "Operationsreason",
      "placeholder": "Enter Number of attempts"
    },
    domProps: {
      "value": (_vm.Operationsreason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Operationsreason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showflag),
      expression: "showflag"
    }],
    staticClass: "text-success"
  }, [_vm._v("Current Value : " + _vm._s(_vm.currentOperationsreason))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Force Majure reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcemajurereason),
      expression: "forcemajurereason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('forcemajurereason')
    },
    attrs: {
      "type": "text",
      "name": "forcemajurereason",
      "id": "forcemajurereason",
      "placeholder": "Enter Number of attempts"
    },
    domProps: {
      "value": (_vm.forcemajurereason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forcemajurereason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showflag),
      expression: "showflag"
    }],
    staticClass: "text-success"
  }, [_vm._v("Current Value : " + _vm._s(_vm.currentforcemajurereason))])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-right": "-1"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.MarkOtherConfiguration
    }
  }, [_vm._v(" Save "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v("  \n          ")], 1)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0986103e","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/configuration/UADConfiguration/otherConfiguration/otherConfiguration.component.html
// module id = 1386
// module chunks = 3